import Api from "@root/components/api";
import { type } from "jquery";
import Helper from "../helper";

export default class ChallengeMutation {
    async publish(challengeId) {
        let query = `mutation ($challengeId: String!) {
            publishChallenge(challengeId: $challengeId)
        }`;    
        const response = await Api.postData('/g', { 
            query: query, 
            variables: {
                challengeId: challengeId,
            }
        });
        return response.data.publishChallenge;
    }

    async unpublish(challengeId) {
        let query = `mutation ($challengeId: String!) {
            unpublishChallenge(challengeId: $challengeId)
        }`;    
        const response = await Api.postData('/g', { 
            query: query, 
            variables: {
                challengeId: challengeId,
            }
        });
        return response.data.unpublishChallenge;
    }

    async save(challenge) {
        let query = `mutation ($input: ChallengeInput!) {
            saveChallenge(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: challenge.id,
                name: challenge.name, 
                description: challenge.description,
                background: challenge.imageUrl,
                primarySubjectId: challenge.primarySubject?.id,
                games: challenge.gameLinks.map(c=>{
                    return {
                        id: c.miniGame.id,
                        seed: c.params.seed === "" || c.params.seed === undefined ? null : c.params.seed,
                        includeAll: c.params.includeAll,
                        miniBoss: c.params.miniBoss,
                        slides: c.params.slides?.map(s => {
                            return {
                                imageUrl: s.imageUrl,
                                delay: s.delay,
                                manual: s.manual,
                            };
                        }) ?? [],
                    };
                }),
            }
        }});
    }    

    async saveSimple(challenge) {
        let games = [];
        let slides = [];
        for(let item of challenge.items) {
            if (item.type === 'game') {
                const game = item.game;
                games.push({
                    id: item.id,
                    seed: game.simple ? 0 : game.seed ? +game.seed : undefined,
                    includeAll: game.simple || (game.includeAll !== undefined && game.includeAll != null ? game.includeAll : false),
                    miniBoss: null,
                    slides: game.slides,
                    isReference: !game.simple,
                    game: game.simple ? {
                        ...game,
                        background: game.imageUrl,
                        imageUrl: undefined,
                        simple: undefined,
                        name: '',
                        language: 'ru',
                        data: { 
                            [game.gameType[0].toLowerCase() + game.gameType.substring(1) + "Items"]: game.items,
                            [game.gameType[0].toLowerCase() + game.gameType.substring(1) + "Info"]: (game.info || {}),
                        },
                        skills: [],
                        info: undefined,
                        items: undefined,
                        slides: undefined,
                    } : {
                        id: game.id,
                        name: '',
                        language: 'ru',
                        data: {},
                        skills: [],
                    },
                });
                slides = [];
            } else if (item.type === 'slide') {
                slides.push({
                    ...item.slide,
                });              
            } else {
                console.warn("Cannot save unknown type of game", item.type);
            }
        }

        let query = `mutation ($input: ChallengeInput!) {
            saveSimpleChallenge(input: $input)
        }`;
        return await Api.postData('/g', { query: query, variables: {
            input: {
                id: challenge.id,
                name: challenge.name, 
                challengeType: challenge.challengeType,
                description: challenge.description,
                background: challenge.imageUrl,
                primarySubjectId: challenge.primarySubject?.id,
                games: games,
                published: challenge.published,
                params: {
                    premium: false,
                    disableSwitchBrowser: challenge.params.disableSwitchBrowser,
                    reducePointsForSlowAnswer: challenge.params.reducePointsForSlowAnswer,
                    penaltyForIncorrect: challenge.params.penaltyForIncorrect,
                    showResultsAfterEachGame: challenge.params.showResultsAfterEachGame,
                    allowHint: challenge.params.allowHint,
                    allowSkip: challenge.params.allowSkip,
                    allowBots: challenge.params.allowBots,
                    autoStart: challenge.params.autoStart,
                    skipStartScreen: challenge.params.skipStartScreen,
                    duration: challenge.params.duration,
                    rules: challenge.params.rules,
                    countDown: challenge.params.countDown
                }
            }
        }});
    }    

    async joinChallenge(challengeInstanceId, name, watcher) {
        let result = await Api.postData('/api/joinChallenge', {
            challengeInstanceId: challengeInstanceId,
            name: name,
            watcher: !!watcher,
        });
        return result;
    }

    async createChallengeInstance(basedOn, primarySubjectId, challengeType, time, count, rules, games, lang, disableSwitchBrowser, reducePointsForSlowAnswer, showResultsAfterEachGame,
        penaltyForIncorrect, allowHint, allowSkip, allowBots) {
        let query = `mutation ($params: ChallengeInstanceInput!) {
            createChallengeInstance(input: $params) {
                id, name, pin, joinUrl
            }
        }`;
        console.log("Challenge", basedOn, primarySubjectId);

        const response = await Api.postData('/g', { query: query, variables: {
            params: {
                primarySubjectId: primarySubjectId,
                challengeType: challengeType,
                time: +time,
                count: +count,
                rules: rules,
                games: games,
                basedOn: basedOn,
                disableSwitchBrowser: disableSwitchBrowser,
                reducePointsForSlowAnswer: reducePointsForSlowAnswer,
                showResultsAfterEachGame: showResultsAfterEachGame,
                penaltyForIncorrect: penaltyForIncorrect,
                allowHint: allowHint,
                allowSkip: allowSkip,
                allowBots: allowBots,
                lang: lang,
            }
        }});
        return response.data.createChallengeInstance;
    }

    async cloneChallengeInstance(challengeId) {
        let query = `mutation ($challengeId: String!) {
            cloneChallengeInstance(challengeInstanceId: $challengeId) {
                id, name, pin, joinUrl
            }
        }`;
        console.log("Cloning challenge", challengeId);
        const response = await Api.postData('/g', { query: query, variables: {
            challengeId: challengeId,
        }});
        return response.data.cloneChallengeInstance;
    }

    async startChallenge(challengeId) {
        const instance = await this.cloneChallengeInstance(challengeId);
        if (instance) {
            location.href = instance.joinUrl;
        } else {
            Api.showWarning("Challenge not found");
        }
    }

    async startTournamentChallenge(tournamentId, teamName) {
        let query = `mutation ($tournamentId: String!, $teamName: String!) {
            startTournamentChallengeInstance(tournamentId: $tournamentId, teamName: $teamName) {
                id, name, pin, joinUrl
            }
        }`;
        console.log("Starting tournament challenge", tournamentId);
        const response = await Api.postData('/g', { query: query, variables: {
            tournamentId: tournamentId,
            teamName: teamName,
        }});
        return response.data.startTournamentChallengeInstance;
    }
    
    async loadChallengeTasks(lang, basedOn, challengeType) {
        let query = `query ($lang: String!, $challengeType: String!, $basedOn: String!) {
            loadChallengeTasks(lang: $lang, basedOnId: $basedOn, challengeType: $challengeType) {
                id, name, gameType, autoCheck, requirements
                count, time, gameUrl, subjects, language,
                primarySkill {
                    id, name, iknow, exercisePoints,
                    primarySubject { id, name }
                },
                authorId, authorName,
                skills { id, name, iknow }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {
            challengeType: challengeType, 
            basedOn: basedOn,
            lang: lang,
        } });
          return result.data.loadChallengeTasks;
    }
    
    async myLastChallenges() {
        let query = `query {
            myLastChallenges {
                id name timestamp challengeType
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {}});
        return result.data.myLastChallenges;
    }
    
    async loadSimpleChallenge(id) {
        let query = `query ($id: String!) {
            challenge(id: $id) { 
                id name description published imageUrl language canEdit challengeType premium active
                primarySubject { id name likes canLike } 
                gameLinks {
                    miniGame {
                        id name likes canLike gameType autoCheck
                        imageUrl description canEdit my approved published
                        count time gameUrl subjects language requirements
                        info gameData items simple hint
                        primarySkill { 
                            id name iknow exercisePoints
                            primarySubject { id name } 
                        }
                        authorId authorName
                        skills { id name iknow }
                    }
                    params {
                        seed includeAll
                        slides {
                            imageUrl delay manual
                        }
                        miniBoss {
                            roles
                        }
                    }
                }
                params {
                    disableSwitchBrowser reducePointsForSlowAnswer penaltyForIncorrect allowHint 
                    allowSkip allowBots autoStart skipStartScreen duration rules countDown 
                    showResultsAfterEachGame
                }
            }
        }`;
        let result = await Api.postData('/g', { query: query, variables: {
            id: id,
        } });
        return result.data.challenge;
    }

    async run(challengeId) {
        let query = `mutation ($challengeId: String!) {
            runChallenge(challengeId: $challengeId) {
                id, name, pin, joinUrl
            }
        }`;

        const response = await Api.postData('/g', { query: query, variables: {
            challengeId: challengeId
        }});

        const data = response.data.runChallenge;

        if (data) {
            location.href = data.joinUrl;        
        } else {
            Api.showWarning("Challenge not found");
        }
    }

    async runWithBots(challengeId, bots) {
        let query = `mutation ($challengeId: String!, $bots: String!) {
            runWithBots(challengeId: $challengeId, bots: $bots) {
                id, name, pin, joinUrl
            }
        }`;

        const response = await Api.postData('/g', { query: query, variables: {
            challengeId: challengeId,
            bots: bots
        }});

        const data = response.data.runWithBots;

        if (data) {
            location.href = data.joinUrl;        
        } else {
            Api.showWarning("Challenge not found");
        }
    }

    async delete(challengeId) {
        let query = `mutation ($challengeId: String!) {
            deleteChallenge(id: $challengeId)
        }`;

        const response = await Api.postData('/g', { query: query, variables: {
            challengeId: challengeId
        }});

        return response.data.deleteChallenge;
    }
}